import { environment } from '@env/environment';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BaoyingModule } from './app/baoying.module';

if (environment.app.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(BaoyingModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
